import gql from 'graphql-tag';

export const GET_SENDWYRE_RATES = gql`
  query {
    getSendwyreExchangeRates
  }
`;